import { Routes, Route, Navigate } from 'react-router';
import { WelcomePage } from './features/auth/WelcomePage';
import { LoginPage } from './features/auth/LoginPage';
import { RegisterPage } from './features/auth/RegisterPage';
import { ForgotPasswordPage } from './features/auth/ForgotPasswordPage';
import { ResetPasswordPage } from './features/auth/ResetPasswordPage';
import { VerifyEmailPage } from './features/auth/VerifyEmailPage';
import { DashboardLayout } from './layouts/DashboardLayout';
import { DashboardPage } from './features/dashboard/DashboardPage';
import { InterventionsPage } from './features/interventions/InterventionsPage';
import { DocumentsPage } from './features/documents/DocumentsPage';
import { AdminPage } from './features/admin/AdminPage';
import { SelectivesPage } from './features/selectives/SelectivesPage';
import { AvailabilityPage } from './features/availability/AvailabilityPage';
import { VehiclesPage } from './features/vehicles/VehiclesPage';
import { WarehousePage } from './features/warehouse/WarehousePage';
import { HydrantsPage } from './features/hydrants/HydrantsPage';
import { ChatPage } from './features/chat/ChatPage';
// SarPage (Ricerca Persona) temporaneamente disabilitata — feature in sviluppo.
// import { SarPage } from './features/sar/SarPage';
import { LockerPage } from './features/locker/LockerPage';
import { DeadlinesPage } from './features/deadlines/DeadlinesPage';
import { TrainingPage } from './features/training/TrainingPage';
import { SelectiveStatsPage } from './features/selectives/SelectiveStatsPage';
import { TenantsPage } from './features/admin/TenantsPage';
import { SettingsPage } from './features/settings/SettingsPage';
import { MyTenantPage } from './features/admin/MyTenantPage';
import { ChartsPage } from './features/interventions/ChartsPage';
import { PrivacyPolicyPage } from './features/legal/PrivacyPolicyPage';

export function App(): React.JSX.Element {
  return (
    <Routes>
      <Route path="/" element={<WelcomePage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/verify-email" element={<VerifyEmailPage />} />
      <Route path="/privacy" element={<PrivacyPolicyPage />} />
      <Route path="/hydrants-public" element={<HydrantsPage publicView />} />
      {/* Bryan: mappa idranti fullscreen sia da pubblico sia da utente loggato
          (non dentro DashboardLayout, cosi' niente header e mappa a tutto schermo) */}
      <Route path="/hydrants" element={<HydrantsPage />} />

      <Route element={<DashboardLayout />}>
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/interventions" element={<InterventionsPage />} />
        <Route path="/selectives" element={<SelectivesPage />} />
        <Route path="/selective-stats" element={<SelectiveStatsPage />} />
        <Route path="/availability" element={<AvailabilityPage />} />
        <Route path="/vehicles" element={<VehiclesPage />} />
        <Route path="/warehouse" element={<WarehousePage />} />
        <Route path="/chat" element={<ChatPage />} />
        <Route path="/documents" element={<DocumentsPage />} />
        {/* Ricerca Persona in sviluppo: la pagina non si apre (redirect). */}
        <Route path="/sar" element={<Navigate to="/dashboard" replace />} />
        <Route path="/locker" element={<LockerPage />} />
        <Route path="/deadlines" element={<DeadlinesPage />} />
        <Route path="/training" element={<TrainingPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/tenants" element={<TenantsPage />} />
        <Route path="/my-tenant" element={<MyTenantPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/charts" element={<ChartsPage />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
